var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path2, _rect16, _circle, _path3, _path4, _rect17, _rect18, _g, _rect19, _rect20, _g2, _rect21, _rect22, _rect23, _path5, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriversLicenseBothBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.90625,
    y: 13.374,
    width: 1.06653,
    height: 7.46567,
    fill: "#C8253C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.90625,
    y: 14.4404,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(-90 5.90625 14.4404)",
    fill: "#C8253C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 117.359,
    y: 13.374,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(90 117.359 13.374)",
    fill: "#C8253C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116.289,
    y: 13.374,
    width: 1.06653,
    height: 7.46567,
    fill: "#C8253C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.90625,
    y: 110.962,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(-90 5.90625 110.962)",
    fill: "#C8253C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 117.359,
    y: 110.962,
    width: 1.06653,
    height: 7.46567,
    transform: "rotate(-180 117.359 110.962)",
    fill: "#C8253C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.97656,
    y: 110.962,
    width: 1.06653,
    height: 7.46567,
    transform: "rotate(-180 6.97656 110.962)",
    fill: "#C8253C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 117.359,
    y: 109.895,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(90 117.359 109.895)",
    fill: "#C8253C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3752_75336)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.5234 96.3066C91.5234 97.0424 90.7491 97.6395 89.7939 97.6396L34.2061 97.6396C33.2507 97.6396 32.4756 97.0425 32.4756 96.3066L32.4756 68.6416C32.4756 67.4198 33.4667 66.4287 34.6885 66.4287L89.7939 66.4287C90.7491 66.4289 91.5234 67.0259 91.5234 67.7617L91.5234 96.3066Z",
    fill: "url(#paint0_linear_3752_75336)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 32.4766,
    y: 74.0205,
    width: 59.0475,
    height: 5.90475,
    fill: "black",
    fillOpacity: 0.54
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 11.8095,
    height: 0.90816,
    rx: 0.45408,
    transform: "matrix(1 -1.27572e-08 -5.19345e-06 1 35.8516 69.8027)",
    fill: "#83888E",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 13.9247,
    height: 0.90816,
    rx: 0.45408,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 35.8516 84.9863)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 13.9247,
    height: 0.90816,
    rx: 0.45408,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 35.8516 89.2041)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 16.7282,
    height: 0.90816,
    rx: 0.45408,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 35.8516 93.4219)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 13.969,
    height: 0.90816,
    rx: 0.45408,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 35.8516 87.0957)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 11.4161,
    height: 0.90816,
    rx: 0.45408,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 35.8516 91.3125)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.1
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7168 83.7217C87.0942 83.7217 89.8328 86.4595 89.833 89.8369C89.833 93.2145 87.0944 95.9531 83.7168 95.9531C82.7786 95.9531 81.8902 95.7409 81.0957 95.3633C81.8555 95.0023 82.5282 94.4891 83.0762 93.8633C83.2849 93.8962 83.4988 93.9141 83.7168 93.9141C85.9682 93.9139 87.7937 92.0893 87.7939 89.8379C87.7939 87.5863 85.9684 85.7609 83.7168 85.7607C83.4989 85.7607 83.2849 85.7776 83.0762 85.8105C82.5281 85.1849 81.8555 84.6714 81.0957 84.3105C81.8901 83.9331 82.7788 83.7217 83.7168 83.7217ZM79.1152 85.8105C79.8623 85.9283 80.5416 86.2495 81.0957 86.7148C80.2055 87.4628 79.6396 88.5842 79.6396 89.8379C79.6398 91.0911 80.2059 92.2113 81.0957 92.959C80.5415 93.4245 79.8625 93.7455 79.1152 93.8633C78.1733 92.7874 77.6016 91.3791 77.6016 89.8369C77.6017 88.2947 78.1732 86.8863 79.1152 85.8105Z",
    fill: "black",
    fillOpacity: 0.6
  })))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 70.8601,
    y: 88.5711,
    width: 35.4282,
    height: 35.4282
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.48px)",
      clipPath: "url(#bgblur_0_3752_75336_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 2.95238,
    x: 73.8125,
    y: 91.5234,
    width: 29.5238,
    height: 29.5238,
    rx: 14.7619,
    fill: "#DF2B44",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.5751,
    cy: 106.285,
    r: 11.8095,
    fill: "#DF2B44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2998 101.014C92.8488 100.465 93.7391 100.465 94.2881 101.014C94.8371 101.563 94.837 102.453 94.2881 103.002L90.7832 106.507L94.2881 110.012C94.837 110.561 94.8371 111.451 94.2881 112C93.7391 112.549 92.8488 112.549 92.2998 112L88.7949 108.495L85.29 112C84.741 112.549 83.8507 112.549 83.3018 112C82.7529 111.451 82.7529 110.561 83.3018 110.012L86.8066 106.507L83.3018 103.002C82.753 102.453 82.7528 101.563 83.3018 101.014C83.8507 100.465 84.741 100.465 85.29 101.014L88.7949 104.519L92.2998 101.014ZM94.0752 101.775L94.0762 101.776L94.0752 101.775ZM84.6748 101.286H84.6758H84.6748Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3752_75336)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5234 55.7109C91.5234 56.4467 90.7491 57.0438 89.7939 57.0439L34.2061 57.0439C33.2507 57.0439 32.4756 56.4468 32.4756 55.7109L32.4756 28.0449C32.4758 26.8235 33.466 25.8332 34.6875 25.833L89.7939 25.833C90.7491 25.8332 91.5234 26.4302 91.5234 27.166L91.5234 55.7109Z",
    fill: "url(#paint1_linear_3752_75336)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 35.8516,
    y: 36.167,
    width: 13.4589,
    height: 13.4588,
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3752_75336",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 36,
    width: 15,
    height: 14
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 35.8516,
    y: 36.167,
    width: 13.4589,
    height: 13.4588,
    fill: "#F9F9F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3752_75336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5919 39.7955L39.4961 40.5662C39.3032 42.1181 40.5147 43.4882 42.0785 43.4882C42.3765 43.4882 42.6725 43.5395 42.953 43.64C44.6416 44.245 46.4196 42.9933 46.4196 41.1996V40.2899C46.4196 39.8792 46.2864 39.4797 46.0401 39.1512L45.5366 38.4798C45.143 37.9549 44.6248 37.5364 44.0287 37.2621C43.0026 36.7898 41.7853 37.126 41.1471 38.0582L40.983 38.2979C40.2452 38.4455 39.6848 39.0489 39.5919 39.7955Z",
    fill: "#494C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0781 53.2505V49.8778C37.0781 48.0064 38.5605 46.4714 40.4308 46.4061L41.3508 46.374H43.9579L44.8024 46.404C46.6969 46.4713 48.2212 47.9839 48.303 49.8778V53.2505L42.6289 54.3507L37.0781 53.2505Z",
    fill: "#BBC3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.375 46.1548V45.006C41.375 44.8457 41.5049 44.7158 41.6652 44.7158H43.5512C43.7114 44.7158 43.8414 44.8457 43.8414 45.006V46.1548C43.8414 46.2101 43.8571 46.2642 43.8868 46.3108L44.2527 46.8859C44.3157 46.9849 44.3491 47.0998 44.3491 47.2171C44.3491 47.3866 44.2794 47.5486 44.1564 47.6652L43.8072 47.9959C43.1714 48.598 42.1828 48.6203 41.5205 48.0476L41.0729 47.6605C40.9423 47.5475 40.8672 47.3834 40.8672 47.2106C40.8672 47.0975 40.8994 46.9868 40.9601 46.8914L41.3296 46.3108C41.3592 46.2642 41.375 46.2101 41.375 46.1548Z",
    fill: "#A2ABB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7635 42.4924L45.5552 42.9437C45.482 43.1022 45.3467 43.2234 45.1811 43.2786C45.0688 43.316 44.9765 43.3975 44.9254 43.5043L44.5408 44.3086C44.3272 44.7554 43.9461 45.1 43.4801 45.2677L43.3561 45.3124C42.7342 45.5363 42.0535 45.5363 41.4316 45.3124C40.9006 45.1212 40.5024 44.6745 40.3731 44.1252L40.1548 43.1971C40.0526 42.7626 40.0363 42.3124 40.1068 41.8717L40.1518 41.59C40.2433 41.0181 40.4361 40.4672 40.721 39.963L41.1194 39.2581C41.178 39.1543 41.3173 39.1309 41.4067 39.2097L42.42 40.104C42.4506 40.131 42.4865 40.1512 42.5254 40.1634L43.627 40.5077L44.0398 40.6815C44.6313 40.9306 45.0306 41.4931 45.0707 42.1337C45.0728 42.1674 45.1175 42.1775 45.1339 42.148L45.277 41.8905C45.3516 41.756 45.5421 41.7483 45.6274 41.8763L45.7271 42.0258C45.8195 42.1644 45.8333 42.3411 45.7635 42.4924Z",
    fill: "url(#paint2_linear_3752_75336)"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3984,
    y: 41.8604,
    width: 6.72933,
    height: 6.72931,
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3752_75336",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 81,
    y: 41,
    width: 8,
    height: 8
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3984,
    y: 41.8604,
    width: 6.72933,
    height: 6.72931,
    fill: "#F9F9F9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3752_75336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.2608 43.6746L83.2129 44.0599C83.1164 44.8359 83.7222 45.5209 84.5041 45.5209C84.6531 45.5209 84.8011 45.5466 84.9413 45.5968C85.7856 45.8993 86.6746 45.2735 86.6746 44.3766V43.9217C86.6746 43.7164 86.608 43.5167 86.4848 43.3524L86.2331 43.0168C86.0363 42.7543 85.7772 42.545 85.4792 42.4079C84.9661 42.1717 84.3575 42.3399 84.0384 42.8059L83.9563 42.9258C83.5874 42.9996 83.3072 43.3013 83.2608 43.6746Z",
    fill: "#494C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0078 50.402V48.7157C82.0078 47.7801 82.749 47.0126 83.6841 46.9799L84.1441 46.9639H85.4476L85.8699 46.9789C86.8171 47.0125 87.5793 47.7688 87.6201 48.7157V50.402L84.7831 50.9521L82.0078 50.402Z",
    fill: "#BBC3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1523 46.8542V46.2799C84.1523 46.1997 84.2173 46.1348 84.2974 46.1348H85.2404C85.3205 46.1348 85.3855 46.1997 85.3855 46.2799V46.8542C85.3855 46.8819 85.3934 46.9089 85.4082 46.9322L85.5912 47.2198C85.6227 47.2693 85.6394 47.3267 85.6394 47.3854C85.6394 47.4701 85.6045 47.5511 85.543 47.6094L85.3684 47.7748C85.0505 48.0758 84.5562 48.087 84.2251 47.8006L84.0013 47.6071C83.936 47.5506 83.8984 47.4685 83.8984 47.3822C83.8984 47.3256 83.9146 47.2702 83.9449 47.2225L84.1296 46.9322C84.1444 46.9089 84.1523 46.8819 84.1523 46.8542Z",
    fill: "#A2ABB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3504 45.0225L86.2463 45.2482C86.2097 45.3274 86.142 45.388 86.0592 45.4156C86.0031 45.4344 85.9569 45.4751 85.9314 45.5285L85.7391 45.9306C85.6323 46.154 85.4418 46.3263 85.2088 46.4102L85.1468 46.4325C84.8358 46.5445 84.4955 46.5445 84.1845 46.4325C83.9191 46.3369 83.7199 46.1136 83.6553 45.8389L83.5461 45.3749C83.495 45.1577 83.4869 44.9325 83.5221 44.7122L83.5447 44.5713C83.5904 44.2854 83.6868 44.0099 83.8292 43.7579L84.0284 43.4054C84.0577 43.3535 84.1274 43.3418 84.1721 43.3812L84.6787 43.8283C84.694 43.8418 84.712 43.852 84.7314 43.858L85.2822 44.0302L85.4886 44.1171C85.7844 44.2416 85.984 44.5229 86.004 44.8432C86.0051 44.86 86.0275 44.8651 86.0357 44.8503L86.1072 44.7216C86.1445 44.6544 86.2398 44.6505 86.2824 44.7145L86.3323 44.7893C86.3784 44.8586 86.3853 44.9469 86.3504 45.0225Z",
    fill: "url(#paint3_linear_3752_75336)"
  })))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 18.9618,
    height: 0.908161,
    rx: 0.45408,
    transform: "matrix(1 -1.27572e-08 -5.19345e-06 1 69.1719 37.2207)",
    fill: "#83888E",
    fillOpacity: 0.5
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 18.9796,
    height: 0.908161,
    rx: 0.45408,
    transform: "matrix(1 -1.95549e-08 -3.38809e-06 1 69.1719 39.1602)",
    fill: "#83888E",
    fillOpacity: 0.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 8.86289,
    height: 0.908161,
    rx: 0.45408,
    transform: "matrix(1 -1.27572e-08 -5.19345e-06 1 79.2891 50.2959)",
    fill: "#83888E",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6214 52.9445C43.5556 52.2067 43.9409 50.6095 43.8498 49.4933C43.7726 48.5467 43.0895 48.4684 42.2721 48.7548C41.002 49.1998 39.6115 49.962 39.3494 51.3698C39.1558 52.4095 39.0159 54.145 40.3566 54.479C41.5036 54.7647 42.3742 53.1921 42.2953 52.2146C42.2548 51.7119 41.5851 51.9281 41.5094 52.3152C41.3012 53.3802 42.5081 53.8995 43.419 53.7606C43.8798 53.6903 44.2322 53.4053 44.5019 53.0451C44.5568 52.9717 44.6681 52.6356 44.8046 52.7319C45.1829 52.9986 45.5826 53.1777 45.9749 53.41",
    stroke: "#83888E",
    strokeOpacity: 0.8,
    strokeWidth: 0.421768,
    strokeLinecap: "round"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 10.4019,
    height: 0.908161,
    rx: 0.45408,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 51.4531 36.167)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 13.9247,
    height: 0.908161,
    rx: 0.45408,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 51.4531 41.0205)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 21.1773,
    height: 0.908161,
    rx: 0.45408,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 51.4531 48.7061)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 4.33768,
    height: 0.908161,
    rx: 0.45408,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 51.4531 38.1064)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 7.84587,
    height: 0.908161,
    rx: 0.45408,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 51.4531 42.96)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 21.4131,
    height: 0.908161,
    rx: 0.45408,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 51.4531 50.6445)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7109 31.7371V29.2832H66.3645V29.711H65.2298V30.2957H66.2794V30.7234H65.2298V31.3094H66.3693V31.7371H64.7109Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5665 29.9893C63.557 29.8926 63.5158 29.8175 63.4431 29.764C63.3704 29.7105 63.2718 29.6838 63.1472 29.6838C63.0625 29.6838 62.991 29.6957 62.9327 29.7197C62.8744 29.7429 62.8296 29.7752 62.7985 29.8168C62.7681 29.8583 62.753 29.9054 62.753 29.9581C62.7514 30.0021 62.7605 30.0404 62.7805 30.0732C62.8013 30.1059 62.8296 30.1343 62.8656 30.1582C62.9015 30.1814 62.9431 30.2018 62.9902 30.2193C63.0373 30.2361 63.0877 30.2505 63.1412 30.2625L63.3616 30.3152C63.4687 30.3392 63.5669 30.3711 63.6564 30.4111C63.7459 30.451 63.8234 30.5001 63.8889 30.5584C63.9544 30.6168 64.0051 30.6854 64.041 30.7645C64.0778 30.8436 64.0965 30.9343 64.0973 31.0365C64.0965 31.1867 64.0582 31.3169 63.9823 31.4271C63.9072 31.5366 63.7986 31.6216 63.6564 31.6824C63.515 31.7423 63.3445 31.7722 63.1448 31.7722C62.9467 31.7722 62.7741 31.7419 62.6271 31.6812C62.481 31.6204 62.3667 31.5306 62.2845 31.4116C62.203 31.2917 62.1602 31.1436 62.1562 30.967H62.6583C62.6639 31.0493 62.6875 31.118 62.729 31.1731C62.7713 31.2274 62.8276 31.2686 62.8979 31.2965C62.969 31.3237 63.0493 31.3373 63.1388 31.3373C63.2266 31.3373 63.3029 31.3245 63.3676 31.2989C63.4331 31.2734 63.4839 31.2378 63.5198 31.1923C63.5558 31.1468 63.5737 31.0944 63.5737 31.0353C63.5737 30.9802 63.5574 30.9339 63.5246 30.8963C63.4926 30.8588 63.4455 30.8268 63.3832 30.8005C63.3217 30.7741 63.2462 30.7502 63.1568 30.7286L62.8896 30.6615C62.6827 30.6112 62.5193 30.5325 62.3995 30.4254C62.2797 30.3184 62.2202 30.1742 62.221 29.9929C62.2202 29.8443 62.2597 29.7145 62.3396 29.6035C62.4203 29.4924 62.5309 29.4058 62.6715 29.3435C62.8121 29.2812 62.9718 29.25 63.1508 29.25C63.3329 29.25 63.4918 29.2812 63.6276 29.3435C63.7642 29.4058 63.8705 29.4924 63.9464 29.6035C64.0223 29.7145 64.0614 29.8431 64.0638 29.9893H63.5665Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5369 29.2832V31.7371H61.0888L60.0212 30.1926H60.0032V31.7371H59.4844V29.2832H59.9397L60.9989 30.8265H61.0205V29.2832H61.5369Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1484 31.7371V29.2832H58.802V29.711H57.6673V30.2957H58.7169V30.7234H57.6673V31.3094H58.8068V31.7371H57.1484Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5052 30.1427H55.9804C55.9708 30.0748 55.9512 30.0145 55.9216 29.9617C55.8921 29.9082 55.8541 29.8627 55.8078 29.8251C55.7615 29.7876 55.708 29.7588 55.6473 29.7389C55.5873 29.7189 55.5222 29.7089 55.4519 29.7089C55.3249 29.7089 55.2143 29.7405 55.12 29.8036C55.0258 29.8659 54.9527 29.9569 54.9008 30.0768C54.8488 30.1958 54.8229 30.3404 54.8229 30.5105C54.8229 30.6854 54.8488 30.8324 54.9008 30.9515C54.9535 31.0705 55.027 31.1603 55.1212 31.221C55.2155 31.2818 55.3245 31.3121 55.4484 31.3121C55.5178 31.3121 55.5821 31.3029 55.6413 31.2846C55.7012 31.2662 55.7543 31.2394 55.8006 31.2043C55.847 31.1683 55.8853 31.1248 55.9157 31.0737C55.9468 31.0225 55.9684 30.9642 55.9804 30.8987L56.5052 30.9011C56.4916 31.0138 56.4576 31.1224 56.4033 31.227C56.3498 31.3309 56.2775 31.4239 56.1864 31.5062C56.0962 31.5877 55.9883 31.6524 55.8629 31.7003C55.7383 31.7475 55.5973 31.771 55.44 31.771C55.2211 31.771 55.0254 31.7215 54.8528 31.6224C54.6811 31.5234 54.5453 31.38 54.4455 31.1923C54.3464 31.0046 54.2969 30.7773 54.2969 30.5105C54.2969 30.2429 54.3472 30.0153 54.4478 29.8275C54.5485 29.6398 54.6851 29.4968 54.8576 29.3986C55.0302 29.2995 55.2243 29.25 55.44 29.25C55.5821 29.25 55.714 29.27 55.8354 29.3099C55.9576 29.3499 56.0658 29.4082 56.1601 29.4848C56.2543 29.5607 56.331 29.6538 56.3901 29.764C56.4501 29.8743 56.4884 30.0005 56.5052 30.1427Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6438 29.2832V31.7371H53.125V29.2832H53.6438Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9375 31.7371V29.2832H51.4563V31.3094H52.5083V31.7371H50.9375Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4062 31.7371V29.2832H48.3744C48.5597 29.2832 48.7179 29.3164 48.8489 29.3827C48.9807 29.4482 49.0809 29.5412 49.1496 29.6618C49.2191 29.7817 49.2539 29.9226 49.2539 30.0848C49.2539 30.2478 49.2187 30.3879 49.1484 30.5054C49.0781 30.622 48.9763 30.7115 48.8429 30.7738C48.7103 30.8361 48.5497 30.8672 48.3612 30.8672H47.713V30.4503H48.2773C48.3764 30.4503 48.4587 30.4367 48.5242 30.4095C48.5897 30.3824 48.6384 30.3416 48.6704 30.2873C48.7031 30.233 48.7195 30.1655 48.7195 30.0848C48.7195 30.0033 48.7031 29.9346 48.6704 29.8787C48.6384 29.8228 48.5893 29.7805 48.523 29.7517C48.4575 29.7221 48.3748 29.7074 48.2749 29.7074H47.9251V31.7371H47.4062ZM48.7315 30.6204L49.3414 31.7371H48.7686L48.1719 30.6204H48.7315Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0703 31.7371V29.2832H46.7238V29.711H45.5891V30.2957H46.6388V30.7234H45.5891V31.3094H46.7286V31.7371H45.0703Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.717 29.2832L43.3101 31.1476H43.3328L43.9271 29.2832H44.5023L43.6564 31.7371H42.9878L42.1406 29.2832H42.717Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5813 29.2832V31.7371H41.0625V29.2832H41.5813Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5781 31.7371V29.2832H39.5463C39.7316 29.2832 39.8898 29.3164 40.0208 29.3827C40.1526 29.4482 40.2528 29.5412 40.3215 29.6618C40.391 29.7817 40.4258 29.9226 40.4258 30.0848C40.4258 30.2478 40.3906 30.3879 40.3203 30.5054C40.25 30.622 40.1482 30.7115 40.0148 30.7738C39.8822 30.8361 39.7216 30.8672 39.5331 30.8672H38.8849V30.4503H39.4492C39.5483 30.4503 39.6305 30.4367 39.6961 30.4095C39.7616 30.3824 39.8103 30.3416 39.8422 30.2873C39.875 30.233 39.8914 30.1655 39.8914 30.0848C39.8914 30.0033 39.875 29.9346 39.8422 29.8787C39.8103 29.8228 39.7612 29.7805 39.6949 29.7517C39.6294 29.7221 39.5467 29.7074 39.4468 29.7074H39.0969V31.7371H38.5781ZM39.9033 30.6204L40.5132 31.7371H39.9405L39.3438 30.6204H39.9033Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7215 31.7371H35.8516V29.2832H36.7286C36.9755 29.2832 37.188 29.3323 37.3661 29.4306C37.5442 29.528 37.6812 29.6682 37.7771 29.8512C37.8737 30.0341 37.9221 30.253 37.9221 30.5078C37.9221 30.7634 37.8737 30.9831 37.7771 31.1668C37.6812 31.3505 37.5434 31.4915 37.3637 31.5897C37.1848 31.688 36.9707 31.7371 36.7215 31.7371ZM36.3704 31.2926H36.6999C36.8533 31.2926 36.9823 31.2654 37.0869 31.2111C37.1924 31.156 37.2714 31.0709 37.3242 30.9559C37.3777 30.8401 37.4044 30.6907 37.4044 30.5078C37.4044 30.3264 37.3777 30.1783 37.3242 30.0632C37.2714 29.9482 37.1928 29.8635 37.0881 29.8092C36.9835 29.7549 36.8545 29.7277 36.7011 29.7277H36.3704V31.2926Z",
    fill: "black",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3752_75336",
    x: 16.9905,
    y: 54.2611,
    width: 85.5944,
    height: 57.7584,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.21229,
    dy: 1.10615
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.63687
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.239216 0 0 0 0 0.392157 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3752_75336"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3752_75336",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_3752_75336_clip_path",
    transform: "translate(-70.8601 -88.5711)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.8125,
    y: 91.5234,
    width: 29.5238,
    height: 29.5238,
    rx: 14.7619
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3752_75336",
    x: 16.9905,
    y: 13.6654,
    width: 85.5944,
    height: 57.7585,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.21229,
    dy: 1.10615
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.63688
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.239216 0 0 0 0 0.392157 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3752_75336"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3752_75336",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3752_75336",
    x1: 33.7099,
    y1: 82.6476,
    x2: 109.739,
    y2: 76.3684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607628,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3752_75336",
    x1: 33.7099,
    y1: 42.0519,
    x2: 109.739,
    y2: 35.7727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607628,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3752_75336",
    x1: 41.24,
    y1: 40.0787,
    x2: 44.0568,
    y2: 44.7176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABB4BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3752_75336",
    x1: 84.0888,
    y1: 43.8157,
    x2: 85.4971,
    y2: 46.1351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABB4BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriversLicenseBothBad);
export default __webpack_public_path__ + "static/media/DriversLicenseBothBad.1d786f17ffd9b8fd4fcc73444046e367.svg";
export { ForwardRef as ReactComponent };